module.exports = __webpack_public_path__ + "media/components/live/rdc/images/how-it-works-2-0e979d417f35b0db8bc975a9f92f59a5.png";